import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "finish-list-item-tooltip"
}
const _hoisted_2 = ["src"]

import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import CompatibilityModal from "Vue/components/lockDesigner/components/shared/Modals/CompatibilityModal.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    id: String,
    displayName: String,
    description: String,
    imageUrl: String,
    route: String,
    isSelected: Boolean,
    isDisabled: Boolean,
    fieldId: String,
    compatibilityMessage: String,
    compatibilityModalMessage: String
},
  emits: ['update-route', 'update-selection'],
  setup(__props, { emit }) {

const props = __props

const store2 = useStore();



const store = reactive({
    isHovered: false,
});

const isFinishLoading = computed(() => {
    return store2.state.isFinishLoading;
});

const handleSelectionContinue = () => {
	emit('update-selection', { selection: props, fieldId: props.fieldId });
};

const handleSelectFinish = async() => {
	if(props.isDisabled) {
		await store2.dispatch('openModal', {
			component: CompatibilityModal,
			props: { compatibilityModalMessage: props.compatibilityModalMessage, handleContinueSelection: handleSelectionContinue },
		});
		return;
	}
	handleSelectionContinue();
}
function showTooltip() {
    store.isHovered = true;
}
function hideTooltip() {
    store.isHovered = false;
}

const optimizedImageUrl = computed(() => {
    return `${props.imageUrl}&wid=31`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "finish-item",
    key: __props.id
  }, [
    (_unref(store).isHovered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.displayName), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      onMouseover: showTooltip,
      onMouseout: hideTooltip,
      class: "finish-grid-list__item",
      onClick: handleSelectFinish
    }, [
      _createElementVNode("img", {
        src: _unref(optimizedImageUrl),
        alt: "",
        class: _normalizeClass(["finish-grid-list__img", { 'finish-grid-list__img-selected': __props.isSelected, 'finish-grid-list__img-disabled': __props.isDisabled }])
      }, null, 10 /* CLASS, PROPS */, _hoisted_2)
    ], 32 /* HYDRATE_EVENTS */)
  ]))
}
}

})